import { render } from "./App.vue?vue&type=template&id=b423c532"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b423c532&lang=css"

import exportComponent from "D:\\data\\work\\interfase\\crypto\\demo\\bio-web-client\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__